<template>
    <div class="form-box">
        <!-- <div class="form-left">
            <p v-for="(item,index) in dataTree" :key="index" :class="(curId==index?'on':'')" @click="handleNodeClick(item,index)" style="width:100%;height:4vh;position: relative;display: flex;align-content: center;align-items: center;padding-left: 1vh;cursor: pointer;">
                {{item.name}}
            </p>
        </div> -->
        <div class="form-right">
            <div style="width:100%;height:5vh;padding-left:1vw;background:#fff;display:flex;align-items: center;">
                <el-page-header @back="goBack" :content="params.pname+'---'+params.name"></el-page-header>
            </div>
            <!-- <div style="width:100%;height:5vh;padding-left:1vw;background:#fff;display:flex;align-items: center;">
            <div style="width:30%;text-align:left;color:#f00">合计:</div>
                <ul class="ul-s">
                    <li class="li-20">累计审定产值:{{entity.judgementValue}}</li>
                    <li class="li-20">累计工程款支付:{{entity.actualPayment}}</li>
                    <li class="li-20" v-if="unitKind=='2'">累计农民工专户支付: --</li>
                    <li class="li-20" v-else>累计农民工专户支付:{{entity.specialAccount}}</li>
                    <li class="li-20" style="width:25%;" v-if="unitKind=='2'">农民工专户支付比例: --</li>
                    <li class="li-20" style="width:25%;" v-else>农民工专户支付比例:{{entity.specialAccountRatio}}</li>
                    <li class="li-20" style="width:15%;">违约金:{{entity.fine}}</li>
                </ul>
            </div> -->
            <div style="width:100%;height:calc( 100% - 10vh );position: relative;padding:1vh;background:#fff;">
                <el-table :data="tableData" border style="width: 100%" height="100%" :header-row-class-name="'table-head'">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column prop="index" label="汇总">
                        <el-table-column prop="index" label="序号" width="200">
                            <template slot-scope="scope">
                                <span>{{scope.row.index}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="time" label="日期">
                            <template slot-scope="scope">
                                <span>{{scope.row.time}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="entity.judgementValue">
                        <el-table-column prop="apprMoney" label="审定产值">
                            <template slot-scope="scope">
                                <span>{{scope.row.apprMoney}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="entity.actualPayment">
                        <el-table-column prop="payMoney" label="工程款支付">
                            <template slot-scope="scope">
                                <span>{{scope.row.payMoney}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="unitKind=='2'?'--':entity.specialAccount">
                        <el-table-column prop="baseMoney" label="农民工专户支付">
                            <template slot-scope="scope">
                                <span v-if="unitKind=='2'">--</span>
                                <p v-else>{{scope.row.baseMoney}}</p>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="unitKind=='2'?'--':entity.specialAccountRatio">
                        <el-table-column prop="bilv" label="农民工专户支付比例">
                            <template slot-scope="scope">
                                <span v-if="unitKind=='2'">--</span>
                                <span v-else>{{scope.row.bilv}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="entity.fine">
                        <el-table-column prop="damMoney" label="违约金">
                            <template slot-scope="scope">
                                <span >{{scope.row.damMoney}}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    
                    <!-- <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="success" @click="infoFun(scope.row)">查看</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
export default {
    data(){
        return{
            groupId:'',
            dataTree:[],
            defaultProps: {
                children: 'list',
                label: 'name'
            },
            projectId:'',//当前项目id
            dataText: '数据加载中...',
            tableData:[],
            curId:0,
            params:'',
            entity:{
                actualPayment: 0,
                contractPrice: 0,
                fine: 0,
                judgementValue: 0,
                specialAccount: 0,
                specialAccountRatio: 0,

            },
            unitKind:'',
        }
    },
    mounted(){
        var params = this.$route.params
        this.params = params
        this.groupId = util.session.get('groupId')
        // this.getLeftMenu()
        this.getData()
        
    },
    methods:{
        //获取侧边树
        getLeftMenu(){
            var that = this
            myHttp.getEntProjectList({
                groupId: this.groupId,
                pageNum:1,
                pageSize:10000,
              
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.entProject.list || []
                    that.dataTree = list
                    //for(var i=0;i<list.length;i++){
                    if (list.length > 0 && that.projectId=='') {
                        that.projectId= list[0].id
                        that.getData()
                    }
                    //}
                }
            })
        },
        /**统计汇总 */ 
        getToltal(){
            var that = this
            myHttp.selectTotalPayCount({
                entId:this.groupId,
                // entProjectId:this.params.id,
                contractId:this.params.id
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.entity
                    that.entity =list
                    
                }else{
                     that.dataText = '暂无数据'
                }
            })
        },
        //树形点击
        handleNodeClick(e,index){
            this.projectId = e.id
            this.curId = index
            this.getData()
        },
        //获取数据
        getData(){
            var that = this
            this.tableData = []
          var that = this
            myHttp.getContractStageByProjectId({
                contractId:this.params.id,
                status:'3',
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data.object
                    that.unitKind = resp.data.data.proContract.unitKind
                    if(data){
                        that.pageTitle = data.contractName
                        // that.unitKind = data.unitKind
                        var list = data.first? JSON.parse(data.first).list:[]
                        for(var i=0;i<list.length;i++){
                            list[i].index = i+1
                            list[i].damMoney = list[i].damMoney?list[i].damMoney:0
                            list[i].payMoney = list[i].payMoney?list[i].payMoney:0
                            list[i].baseMoney = list[i].baseMoney?list[i].baseMoney:0
                            list[i].bilv = list[i].payMoney==0&&list[i].damMoney==0?0:(parseFloat(list[i].baseMoney)/(parseFloat(list[i].damMoney)+parseFloat(list[i].payMoney))*100).toFixed(2)+'%'
                        }
                        that.tableData = list
                        if(list.length==0){
                            that.dataText = '暂无数据'
                        }
                    }else{
                        that.dataText = '暂无数据'
                    }
                    that.getToltal()
                }
            })
        },

        //返回
        goBack(){
            this.$router.go(-1)
        },
    }
}
</script>

<style scoped>
    .form-box{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        padding: 1vh;
    }
    .form-left{
        width:15vw;
        height: 100%;
        position: relative;
        background: #fff;
        padding: 1vh;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        align-items: flex-start;
    }
    .form-left .on{
        color: #2447D7;
    }
    .form-right{
        width: 100%;
        height: 100%;
        position: relative;
        padding-left: 1vh;
    }
     .ul-s{
        width: 80%;
        display: flex;
        text-align: left;
        justify-content: space-between
    }
    .li-20{
        width: 20%
    }
</style>

<style>
    @import '../../../assets/css/common.css';
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>